export function getAcceptFiles(value) {
	const accept = [ 'png', 'jpeg', 'bmp', 'png', 'pdf', 'gif', 'jpg' ];
	const str = value && value.split('.').pop().toLowerCase();

	return accept.includes(str);
}
